import {
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
} from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { participantPortalUrl } from "../../../common/config";
import { Checked } from "../../icons";
import { paymentPlansStyle } from "./paymentPlans.styles";
import {
  FREE_PLAN_SUBSCRIPTION,
  PREMIUM_PLAN_SUBSCRIPTION,
  paymentPlans,
} from "./plans";

export const PaymentPlans = ({ isFreeUser }) => {
  const classes = paymentPlansStyle();

  const onHandleClick = () =>
    window.open(`${participantPortalUrl}/subscribe`, "_blank");

  const planDetail = (planBenefit) => (
    <Grid key={planBenefit.benefit} item xs={12}>
      <Typography
        variant="subtitle1"
        className={clsx(
          classes.planBenefit,
          {
            [classes.disabledBenefit]: !planBenefit.isEnabled,
          },
          {
            [classes.benefitBold]: planBenefit.isBold,
          }
        )}
      >
        <Checked
          isEnabled={planBenefit.isEnabled}
          className={classes.checkedIcon}
        />
        {planBenefit.benefit}
      </Typography>
    </Grid>
  );

  const upgradeMembershipBtn = (planId) => {
    const isFreeSubcription = FREE_PLAN_SUBSCRIPTION === planId;
    const isPremiumSubcription = PREMIUM_PLAN_SUBSCRIPTION === planId;

    if (isFreeUser && isPremiumSubcription) {
      return (
        <Button
          variant="contained"
          color="primary"
          className={classes.upgradeMembership}
          endIcon={<ChevronRightIcon />}
          onClick={onHandleClick}
        >
          Upgrade membership
        </Button>
      );
    }

    if (
      (isFreeUser && isFreeSubcription) ||
      (!isFreeUser && isPremiumSubcription)
    ) {
      return (
        <Typography className={classes.currentPlan}>
          Your current membership
        </Typography>
      );
    }

    return null;
  };

  return (
    <Grid container spacing={2}>
      {paymentPlans.map((plan) => (
        <Grid key={plan.id} item sm={6}>
          <Card>
            <CardContent className={classes.cardContent}>
              <Grid container>
                <Grid item xs={12}>
                  {plan.id === 100 ? (
                    <Typography
                      className={clsx(classes.title, classes.freePlanTitle)}
                    >
                      {plan.title}
                    </Typography>
                  ) : (
                    <Chip
                      label={plan.title}
                      className={clsx(classes.title, classes.premiumPlanTitle)}
                    />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.priceContainer}>
                    <Typography className={classes.priceSign}>$</Typography>
                    <Typography className={classes.price}>
                      {plan.price}
                    </Typography>
                  </div>
                  <Typography className={classes.period}>
                    {plan.period}
                  </Typography>
                  <Typography className={classes.periodDetails}>
                    {plan.periodDetails}
                  </Typography>
                </Grid>
                <div
                  className={clsx(classes.benefitsContainer, {
                    [classes.freeBenefitsContainer]:
                      plan.id === FREE_PLAN_SUBSCRIPTION,
                  })}
                >
                  {plan.details.map((detail) => planDetail(detail))}
                </div>
              </Grid>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className={classes.buttonContainer}
              >
                {upgradeMembershipBtn(plan.id)}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

PaymentPlans.propTypes = {
  isFreeUser: PropTypes.bool.isRequired,
};
